import RoutserApp from "./Routes/RoutserApp";

function App() {
  return (
    <div>
      <RoutserApp />
    </div>
  );
}

export default App;
